import api from "../api";

export const postCreateGradeBook = async (data) => {
    try {
        const response = await api.post(
            '/api/v1/wisdom/create-new-grade-book',
            data
        );
        return response.data;
    } catch (error) {
        console.error('Error creating Grade Book:', error);
        throw error;
    }
};

export const postInsertGradeBookScore = async (data) => {
    try {
        const response = await api.post(
            '/api/v1/wisdom/insert-grade-book-score',
            data
        );
        return response.data;
    } catch (error) {
        console.error('Error creating Grade Book:', error);
        throw error;
    }
};

export const sendTeacherAbsence = async (formData) => {
    try {
        const response = await api.post("/api/v1/wisdom/teacher/absence", formData);
        return response.data?.data || null;
    } catch (error) {
        console.error("Error creating form:", error.response?.data || error.message);
        throw error;
    }
};

export const sendEmployeeAbsence = async (formData) => {
    try {
        const response = await api.post("/api/v1/wisdom/employee-absence", formData);
        return response.data?.data || null;
    } catch (error) {
        console.error("Error creating form:", error.response?.data || error.message);
        throw error;
    }
};